import React from "react";

import { IconButton, IconButtonProps } from "@mui/material";
import { CalculateMeasure } from "assets/material-custom-icons";

export const CalculateButton: React.FC<IconButtonProps> = (props) => {
  return (
    <IconButton
      sx={{
        "&.Mui-disabled": {
          background: "#eaeaea",
          color: "#c0c0c0"
        },
        height: "42px",
        width: "38px",
        bgcolor: "#0A3142",
        borderRadius: 0,

        ":hover": {
          bgcolor: "#0A3142"
        }
      }}
      {...props}
    >
      <CalculateMeasure />
    </IconButton>
  );
};
